import { BLACK_d } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 192rem;
  height: 125.6rem;
  // 디자인 컴포넌트에서 배경 해결
  /* background: linear-gradient(180deg, #101010 0%, #000000 21.35%, #000000 77.08%, #101010 100%);
  background-color: transparent; */
  margin-left: -36rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 37.5rem;
    margin-left: -20px;
    height: 114.4rem;
  }
`;
export const Container = styled.div`
  padding-left: 36rem;
  display: flex;
  flex-direction: column;
  gap: 9.7rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    padding-left: 20px;
    gap: 14.4rem;
  }
`;
export const FirstBox = styled.div`
  display: flex;
  margin-top: 16.3rem;
  gap: 8rem;
  align-items: center;
  & > img {
    margin-left: 20.9rem;
    width: 30rem;
    height: 30rem;
  }

  & > div {
    width: 47.5rem;
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    flex-direction: column;
    margin-top: 10rem;
    gap: 2rem;
    align-items: baseline;
    & > img {
      margin-left: 0rem;
      width: 16.6rem;
      height: 16.6rem;
    }

    & > div {
      padding-left: 2rem;
      padding-right: 20px;
      width: 100%;
    }
  }
`;
export const SecondBox = styled.div`
  display: flex;
  align-items: center;
  gap: 12.7rem;
  & > img {
    width: 40rem;
    height: 40rem;
  }
  & > div {
    width: 53.5rem;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    flex-direction: column-reverse;
    gap: 2rem;
    align-items: self-end;
    & > img {
      width: 20rem;
      height: 20rem;
    }

    & > div {
      padding-right: 2rem;
      width: 100%;
    }
  }
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  & > span:nth-child(1) {
    font-weight: 700;
    font-size: 4rem;
    line-height: 7rem;
  }
  & > span:nth-child(2) {
    font-weight: 300;
    font-size: 1.8rem;
    line-height: 3.2rem;
    color: ${BLACK_d};
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    gap: 0.5rem;
    & > span:nth-child(1) {
      font-size: 2.2rem;
      line-height: 3.8rem;
    }
    & > span:nth-child(2) {
      font-size: 1.6rem;
      line-height: 2.8rem;
    }
  }
`;
